import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { 
    faEnvelope,
    faGlobe,
    faArrowUp,
    faChevronRight,
} from '@fortawesome/free-solid-svg-icons'
import { 
    faFacebookF,
    faYoutube,
    faXTwitter,
    faInstagram,
    faLinkedinIn,
} from '@fortawesome/free-brands-svg-icons'

library.add(faEnvelope, faGlobe, faArrowUp, faChevronRight, faFacebookF, faYoutube, faXTwitter, faInstagram, faLinkedinIn)
dom.watch()
import '../sass/404.sass';